import React from "react";
import { ToastContainer } from "react-toastify";

export function MyToastContainer(): JSX.Element {
  return (
    <ToastContainer
      containerId="toastUniqueId123"
      draggable={false}
      autoClose={4000}
    />
  );
}
